<template>
   <!--Header-->
   <v-system-bar app
		color="quaternary"
		class="pl-0 pr-0 system-bar-app"
		:height="LAYOUT.headerHeight">
			
		<div class="header-container">
			<div :style="headerContentStyle" class="header-content">

				<div class="header-logo">
					<img src="@/assets/images/header/cropped-logo2.png">
					<div v-if="!isMobile() && !$vuetify.breakpoint.mdAndDown" class="quaternary-bg header-title">{{ HEADER_TITLE }}</div>
				</div>

				<NavigationMenuMobile v-if="isMobile() || $vuetify.breakpoint.mdAndDown"
					v-bind:prop_user="prop_user"
					v-on:toggle_drawer="$emit('toggle_drawer')">
				</NavigationMenuMobile>

				<!-- Header Main Menu -->
				<navigation-menu v-else 
					v-bind:prop_user="prop_user">
				</navigation-menu>
		</div>

		<div :style="headerBorderStyle"></div>

		</div>
			
	</v-system-bar>
</template>

<style scoped>
	.system-bar-app {
		z-index: 10;
	}
	.header-container {
		height: 100%;
		width: 100%;
	}

	.header-content {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.header-logo {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}
	.header-logo img {
		width: 120px;
		padding-top: 4px;
	}
	.header-title {
		font-size: 18px;
		padding-top: 16px;
		margin-left: 15px;
		font-weight: bold;

	}
</style>

<script>
import '@/assets/css/app.css';
import '@/assets/css/utils.css';

const { Utils } = require('@/assets/js/scripts/utils/Utils');
import { LAYOUT } from '@/configs/layoutConfigs.js';
import NavigationMenu from '@/components/header/NavigationMenu';
import NavigationMenuMobile from '@/components/header/NavigationMenuMobile';

export default {
  	name: 'Header',
  	props: [
      'prop_user',
  	],

  	components: {
   	NavigationMenu,
		NavigationMenuMobile,
  	},

  	computed: {
   	headerContentStyle() {
      	return {
        		height: ( LAYOUT.headerHeight - LAYOUT.headerBorderHeight ) + "px"
      	}
    	},
    	headerBorderStyle() {
      	return {
        		height: LAYOUT.headerBorderHeight + "px",
		  		backgroundColor: LAYOUT.headerBorderColor,
   		}
    	},
  	},

  	data() {
   	return {
			LAYOUT,
			HEADER_TITLE: "Sistema Informativo per la Gestione ed il Monitoraggio delle informazioni e dei procedimenti Ambientali della Direttiva Alluvioni"
   	}
  	},

	methods: {
		isMobile() {
			return Utils.isSmartphone();
			//return true;
		},
	},

};
</script>
